import type { Article } from './articleApi';

/** 記事編集フォーム・フィルタで共通利用するカテゴリ候補 */
export const ARTICLE_FORM_CATEGORY_OPTIONS = [
  '国内旅行',
  '海外旅行',
  'グルメ',
  '文化・歴史',
  'アクティビティ',
] as const;

/**
 * 記事が属するカテゴリ名の配列（重複除去・空除去）
 * 旧データは category のみ。複数は「・」または「,」区切りも許容
 */
export function getArticleCategoryList(article: Article): string[] {
  if (article.categories?.length) {
    return [...new Set(article.categories.map((c) => c.trim()).filter(Boolean))];
  }
  const raw = (article.category || '').trim();
  if (!raw) return [];
  const parts = raw.split(/[・,、]/).map((s) => s.trim()).filter(Boolean);
  return [...new Set(parts.length ? parts : [raw])];
}

/** メタ情報1行用（例: 国内旅行・グルメ） */
export function formatArticleCategoriesLine(article: Article): string {
  return getArticleCategoryList(article).join('・');
}

/** フィルタ: 記事が指定カテゴリに該当するか（複数カテゴリのいずれかで一致） */
export function articleHasCategory(article: Article, category: string): boolean {
  return getArticleCategoryList(article).includes(category);
}
